import { useState, useEffect } from "react";

import CalendarMCell from "./CalendarMCell";

import moment from "moment";

export default ({
  selectedDate,
  numWeek,
  events,
  showWeekends,
  onClickEvent,
  onClickSlot,
  onClickMore,
  onClickTitle,
}) => {
  const [weekDays, setWeekDays] = useState([]);

  const buildWeekRow = () => {
    const date = moment(selectedDate);
    date.startOf("month").startOf("isoWeek");
    date.add(7 * (numWeek - 1), "days");
    const wDays = [];
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    setWeekDays(wDays);
  };

  useEffect(() => {
    buildWeekRow();
  }, [events]);

  return (
    <div className="calendar-calendar-mes-semana">
      <CalendarMCell
        day={weekDays.length > 0 ? weekDays[0] : null}
        selectedDate={selectedDate}
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
        onClickMore={onClickMore}
        onClickTitle={onClickTitle}
      />
      <CalendarMCell
        day={weekDays.length > 0 ? weekDays[1] : null}
        selectedDate={selectedDate}
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
        onClickMore={onClickMore}
        onClickTitle={onClickTitle}
      />
      <CalendarMCell
        day={weekDays.length > 0 ? weekDays[2] : null}
        selectedDate={selectedDate}
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
        onClickMore={onClickMore}
        onClickTitle={onClickTitle}
      />
      <CalendarMCell
        day={weekDays.length > 0 ? weekDays[3] : null}
        selectedDate={selectedDate}
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
        onClickMore={onClickMore}
        onClickTitle={onClickTitle}
      />
      <CalendarMCell
        day={weekDays.length > 0 ? weekDays[4] : null}
        selectedDate={selectedDate}
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
        onClickMore={onClickMore}
        onClickTitle={onClickTitle}
      />
      {showWeekends && (
        <CalendarMCell
          day={weekDays.length > 0 ? weekDays[5] : null}
          selectedDate={selectedDate}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
          onClickMore={onClickMore}
          onClickTitle={onClickTitle}
        />
      )}
      {showWeekends && (
        <CalendarMCell
          day={weekDays.length > 0 ? weekDays[6] : null}
          selectedDate={selectedDate}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
          onClickMore={onClickMore}
          onClickTitle={onClickTitle}
        />
      )}
    </div>
  );
};
